import { YoutubeDialog } from 'global/simple-dialog.src';

(function (fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function () {
    /*------------------------------------*\
        YOUTUBE
    \*------------------------------------*/
    [].forEach.call(document.querySelectorAll('.youtube-trigger'), function (btnElem) {
        var dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id')),
            youtubeDialog = new YoutubeDialog(dialogElem);

        btnElem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            youtubeDialog.show();
        });
    });
});
